import styled from "styled-components";

const BillingFormConfirmationStyles = styled.div`
  background-color: rgba(45, 163, 141, 0.16);
  padding: 16px;
  margin-top: 16px;
  border-radius: 16px;

  ${props => props.theme.media.xxl} {
    max-width: 665px;
    padding: 40px;
  }

  .confirmation-header-container {
    display: flex;
    gap: 20px;
  }

  .confirmation-title {
    display: inline-block;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    color: rgba(18, 23, 36, 0.91);

    ${props => props.theme.media.lg} {
      font-size: 24px;
    }

    ${props => props.theme.media.xxl} {
      font-size: 28px;
    }
  }

  .confirmation-message-container {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: rgba(18, 23, 36, 0.91);
  }

  .confirmation-message {
    margin: 16px 0px;
  }

  .confirmation-email {
    font-weight: 700;
  }
`;

export default BillingFormConfirmationStyles;